import React, { Component } from "react";
import LineNavigator from "line-navigator";
import { Redirect } from "react-router-dom";

import DataService from "./DataService";

import {
  btn,
  btnPrimary,
  formGroup,
  formControl,
  mb5,
  mrAuto,
  mt5,
  dFlex,
  alignItemsBaseline
} from "bootstrap/dist/css/bootstrap.css";

export default class ImportForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      shouldRedirect: false,
      textAreaValue: "",
      batchName: ""
    };

    this.onFileChange = this.onFileChange.bind(this);
    this.onTextAreaUpload = this.onTextAreaUpload.bind(this);
    this.onTextAreaChange = this.onTextAreaChange.bind(this);
    this.onBatchNameChange = this.onBatchNameChange.bind(this);
    this.onBatchSizeSelect = this.onBatchSizeSelect.bind(this);
  }

  /**
   *
   * @param {React.ChangeEvent<HTMLInputElement>} e
   */
  onFileChange(e) {
    const { batchSize } = this.state;
    const file = e.target.files[0];

    if (batchSize) {
      const navigator = new LineNavigator(file);
      const headerValue = "name,url";

      let startLineIndex = 0;

      /**
       * @param {string[]} lines
       * @param {boolean} isEof
       */
      const chunkUpload = async (err, index, lines, isEof, progress) => {
        const batchFileName =
          file.name +
          "-" +
          Math.round(startLineIndex / batchSize)
            .toString()
            .padStart(3, "0");

        // Add header if it's not present
        if (lines[0].toLowerCase().indexOf(headerValue) === -1) {
          lines.unshift(headerValue);
        } else {
          // If header was present - skip by one
          startLineIndex += 1;
        }

        const batchChunk = new File([lines.join("\n")], batchFileName);

        await this.uploadFile(batchChunk);

        if (isEof === false) {
          startLineIndex += batchSize;
          navigator.readLines(startLineIndex, batchSize, chunkUpload);
        }
      };

      navigator.readLines(
        startLineIndex,
        batchSize + 1, // +1 in case the header is present
        chunkUpload
      );
    } else {
      this.uploadFile(file);
    }
  }

  onTextAreaUpload() {
    const { textAreaValue, batchName } = this.state;
    const headerValue = "name,url\n";
    let fileContent = textAreaValue;
    const fileName = batchName || "manual-input";

    if (textAreaValue.toLowerCase().indexOf(headerValue) === -1) {
      fileContent = headerValue + fileContent;
    }

    const file = new File([fileContent], fileName);

    this.uploadFile(file);
  }

  /**
   *
   * @param {File} file
   */
  async uploadFile(file) {
    const brandRequestGroupId = await DataService.createBrandRequestGroup(
      file.name,
      file.name,
      16064
    );
    await DataService.uploadBrandsCsv(file, brandRequestGroupId);

    this.setState({ shouldRedirect: true, brandRequestGroupId });
  }

  onTextAreaChange(event) {
    this.setState({ textAreaValue: event.target.value });
  }

  onBatchNameChange(event) {
    this.setState({ batchName: event.target.value });
  }

  onBatchSizeSelect(event) {
    this.setState({ batchSize: parseInt(event.target.value, 10) });
  }

  render() {
    const {
      shouldRedirect,
      brandRequestGroupId,
      textAreaValue,
      batchName,
      batchSize
    } = this.state;

    const { company } = this.props;

    if (shouldRedirect) {
      return (
        <Redirect
          to={{
            pathname: `/activate/${brandRequestGroupId}`
          }}
        />
      );
    }

    return (
      <div>
        <h2 className={`${mb5}`}>
          <i className="fa fa-folder-o" aria-hidden="true" /> {company}
        </h2>

        <h5>
          <i className="fa fa-list-ul" aria-hidden="true" /> Upload New Batch
        </h5>
        {/* Batch Size Dropdown */}
        <div className={`${formGroup}`}>
          <select
            className={`${formControl}`}
            id="batchSizeSelect"
            value={batchSize}
            onChange={this.onBatchSizeSelect}
          >
            <option>Set Batch Size</option>
            <option>50</option>
            <option>100</option>
            <option>200</option>
            <option>500</option>
          </select>
        </div>
        <div className={`${dFlex} ${alignItemsBaseline}`}>
          <label className={`${btn} ${btnPrimary} ${mrAuto}`}>
            Upload CSV{" "}
            <input
              type="file"
              name="file"
              hidden
              onChange={this.onFileChange}
            />
          </label>
          <h3>
            <i
              className="fa fa-info-circle"
              aria-hidden="true"
              data-toggle="tooltip"
              data-placement="bottom"
              title="The CSV file must contain a first line (header) such as `name,url` or
          `name,url,exampleUrl` (in case of a csv with example url)"
            />
          </h3>
        </div>

        <h5 className={`${mt5}`}>
          <i className="fa fa-list-ul" aria-hidden="true" /> Paste Batch Content
        </h5>
        <div className="form-group">
          <input
            className="form-control"
            placeholder="Batch name"
            value={batchName}
            onChange={this.onBatchNameChange}
          />
        </div>
        <div className="form-group">
          <label>Batch content</label>
          <textarea
            className="form-control"
            rows={3}
            placeholder="Apple, https://www.apple.com&#10;Coca-Cola, http://www.coca-cola.com&#10;etc."
            onChange={this.onTextAreaChange}
            value={textAreaValue}
          />
        </div>
        <div className="form-group">
          <button
            className={`${btn} ${btnPrimary}`}
            onClick={this.onTextAreaUpload}
          >
            Upload text
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/ImportForm.js